import React from "react";

export const Heading = ({ children }) => {
    return (
        <h2 className="text-[28px] md:text-[36px] xl:text-[50px] font-medium leading-[38px] md:leading-[46px] lg:leading-[60px]">
            {children}
        </h2>
    );
};
